import { isHasFeature } from "@/lib/check-feature";

export const SW_EVENTS = {
  Notify: "notify",
  Install: "install",
  Activate: "activate",
  Info: "info",
} as const;

export const PUSH_NOTIFICATION_PROVIDERS = {
  Fsm: "fsm",
  Native: "native",
} as const;

export const CURRENT_PUSH_NOTIFICATION_PROVIDER = isHasFeature("native-push")
  ? PUSH_NOTIFICATION_PROVIDERS.Native
  : PUSH_NOTIFICATION_PROVIDERS.Fsm;
